const API_VER = 'v2.0'
export const SubscriptionEndpoints = {
  PAYMENT_STATUS_URI: `/subscription/api/${API_VER}/subscription/get_subscription_status/`,
}
